import { render, staticRenderFns } from "./videoRecommended.vue?vue&type=template&id=7c75c868&scoped=true"
import script from "./videoRecommended.vue?vue&type=script&lang=js"
export * from "./videoRecommended.vue?vue&type=script&lang=js"
import style0 from "./videoRecommended.vue?vue&type=style&index=0&id=7c75c868&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c75c868",
  null
  
)

export default component.exports